// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import urls from '@src/@core/auth/jwt/urls'
// ** Axios Imports
import axios from 'axios'
import { errorToast, sucessToast } from '../../../components/messageToast/messageToast'


const mapVisaToDinersView = (data = []) => {
    return data.map(item => ({
        ...item,
        value: item.total_transaction,
        iva: item.iva_15,
        base_iva: item.capital_12,

        date_collection: item.voucher_date,

        bin_capture: item.bin_capture || item.card_number?.substring(0, 6) || '',

        reference: item.affiliate_code || item.product_code || ''
    }))
}

const axiosInstance = axios.create({
    baseURL: urls.url + '/cash_management/',
    headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

export const fetchCashManagement = createAsyncThunk(
    'cashManagement/fetchData',
    async ({ page = 1, page_size = 10, search = '', start_date = '', end_date = '', agreement_type = '' }, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams()
            params.append('p', page)
            params.append('page_size', page_size)
            if (search) params.append('search', search)
            if (start_date) params.append('start_date', start_date)
            if (end_date) params.append('end_date', end_date)
            if (agreement_type) params.append('agreement_type', agreement_type)

            const response = await axiosInstance.get(`/automatic-debts/?${params.toString()}`)
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al cargar datos')
            return rejectWithValue(error.response.data)
        }
    }
)

export const fetchTypesCard = createAsyncThunk(
    'cashManagement/fetchTypesCard',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/automatic-debts/types-card/')
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al cargar tipos de tarjeta')
            return rejectWithValue(error.response.data)
        }
    }
)

export const getCashManagement = createAsyncThunk(
    'cashManagement/getData',
    async (id = 1, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/automatic-debts/${id}/`)
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al cargar datos')
            return rejectWithValue(error.response.data)
        }
    }
)

export const addCashManagement = createAsyncThunk(
    'cashManagement/addData',
    async (newData, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/automatic-debts/', newData)
            sucessToast('Registros generados automáticamente')
            // Refrescar lista después de crear
            dispatch(fetchCashManagement())
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al crear cabecera')
            return rejectWithValue(error.response.data)
        }
    }
)

export const saveDebitAutomatic = createAsyncThunk(
    'cashManagement/saveDebitAutomatic',
    async (newData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/automatic-debts/save/', newData)
            sucessToast('Débito automático guardado correctamente')
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al guardar el débito automático')
            return rejectWithValue(error.response.data)
        }
    }
)


export const saveCoopAliValleDebitAutomatic = createAsyncThunk(
    'cashManagement/saveCoopAliValleDebitAutomatic',
    async (newData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/automatic-debts/save_cpaliavalle/', newData)
            sucessToast('Débito automático guardado correctamente')
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al guardar el débito automático')
            return rejectWithValue(error.response.data)
        }
    }
)

export const saveProdubancoDebitAutomatic = createAsyncThunk(
    'cashManagement/saveProdubancoDebitAutomatic',
    async (newData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/automatic-debts/save_produbanco/', newData)
            sucessToast('Débito automático guardado correctamente')
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al guardar el débito automático')
            return rejectWithValue(error.response.data)
        }
    }
)

export const saveDebitAutomaticTC = createAsyncThunk(
    'cashManagement/saveDebitAutomaticTC',
    async (newData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/automatic-debts/save_tc/', newData)
            sucessToast('Débito TC automático guardado correctamente')
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al guardar el débito TC automático')
            return rejectWithValue(error.response.data)
        }
    }
)
export const saveDebitAutomaticDF = createAsyncThunk(
    'cashManagement/saveDebitAutomaticDF',
    async (newData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/automatic-debts/save_df/', newData)
            sucessToast('Débito DF automático guardado correctamente')
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al guardar el débito TC automático')
            return rejectWithValue(error.response.data)
        }
    }
)

export const previewAutomaticDebt = createAsyncThunk(
    'cashManagement/preview',
    async (newData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/automatic-debts/preview_data/`, {
                params: newData
            })
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al obtener vista previa')
            return rejectWithValue(error.response.data)
        }
    }
)

export const fetchDetailsByAutomaticDebt = createAsyncThunk(
    'cashManagement/fetchDetails',
    async ({ id, search }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/automatic-debts/${id}/details/?search=${search}`)
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al obtener detalles')
            return rejectWithValue(error.response.data)
        }
    }
)

export const fetchDetailsByAutomaticDebtTC = createAsyncThunk(
    'cashManagement/fetchDetailsTC',
    async ({ id, search }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/automatic-debts/${id}/details_tc/?search=${search}`)
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al obtener detalles')
            return rejectWithValue(error.response.data)
        }
    }
)


export const fetchDetailsByAutomaticDebtDF = createAsyncThunk(
    'cashManagement/fetchDetailsDF',
    async ({ id, search }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/automatic-debts/${id}/details_df/?search=${search}`)
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al obtener detalles')
            return rejectWithValue(error.response.data)
        }
    }
)

export const updateDetailsByAutomaticDebt = createAsyncThunk(
    'cashManagement/updateDetails',
    async ({ id, details }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/automatic-debts/${id}/update-details/`, details)
            sucessToast('Registros actualizados correctamente')

            // Opcional: volver a traer los detalles actualizados
            dispatch(getCashManagement(id))
            dispatch(fetchDetailsByAutomaticDebt({ id, search: '' }))

            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al actualizar detalles')
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const updateDetailsByAutomaticDebtTC = createAsyncThunk(
    'cashManagement/updateDetailsTC',
    async ({ id, details }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/automatic-debts/${id}/update-details-tc/`, details)
            sucessToast('Registros actualizados correctamente')

            // Opcional: volver a traer los detalles actualizados
            dispatch(getCashManagement(id))
            dispatch(fetchDetailsByAutomaticDebtTC({ id, search: '' }))

            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al actualizar detalles')
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const updateDetailsByAutomaticDebtDF = createAsyncThunk(
    'cashManagement/updateDetailsDF',
    async ({ id, details }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/automatic-debts/${id}/update-details-df/`, details)
            sucessToast('Registros actualizados correctamente')

            // Opcional: volver a traer los detalles actualizados
            dispatch(getCashManagement(id))
            dispatch(fetchDetailsByAutomaticDebtDF({ id, search: '' }))

            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al actualizar detalles')
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const processRecurrentDebit = createAsyncThunk(
    'cashManagement/processRecurrentDebit',
    async ({ id, details }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/automatic-debts/${id}/process_df/`, details)
            sucessToast('Registros actualizados correctamente')
            dispatch(getCashManagement(id))
            dispatch(fetchDetailsByAutomaticDebtDF({ id, search: '' }))
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al actualizar detalles')
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const loadDebitAutomatic = createAsyncThunk(
    'cashManagement/loadDebitAutomatic',
    async ({ id, file, formato }, { rejectWithValue }) => {
        try {
            const formData = new FormData()
            formData.append('file', file)
            formData.append('formato', formato)
            const response = await axiosInstance.post(`/automatic-debts/${id}/load_debits/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            sucessToast('Archivo cargado correctamente')
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al cargar el archivo')
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const saveMigrateDebitAutomatic = createAsyncThunk(
    'cashManagement/saveMigrateDebitAutomatic',
    async ({ id, details }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/automatic-debts/${id}/save_migrate_cobro/`, details)
            sucessToast('Registros actualizados correctamente')
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al migrar los cobros')
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const saveMigrateDebitAutomaticTC = createAsyncThunk(
    'cashManagement/saveMigrateDebitAutomaticTC',
    async ({ id, details }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/automatic-debts/${id}/save_migrate_cobro_tc/`, details)
            sucessToast('Registros actualizados correctamente')
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al migrar los cobros')
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const deleteAutomaticDebt = createAsyncThunk(
    'cashManagement/deleteAutomaticDebt',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            await axiosInstance.delete(`/automatic-debts/${id}/`)
            sucessToast('Debito automático eliminado correctamente')
            // Refrescar lista después de eliminar
            dispatch(fetchCashManagement({}))
            return id
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al eliminar debito automático')
            return rejectWithValue(error.response.data)
        }
    }
)
export const fetchDetailsByAutomaticDebtDinersTC = createAsyncThunk(
    'cashManagement/fetchDetailsDinersTC',
    async ({ id, search }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/automatic-debts/${id}/details_tc/?search=${search}`)
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al obtener detalles')
            return rejectWithValue(error.response.data)
        }
    }
)

export const saveDebitAutomaticDinersTC = createAsyncThunk(
    'cashManagement/saveDebitAutomaticDinersTC',
    async (newData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/automatic-debts/save_diners_tc/', newData)
            sucessToast('Débito Diners TC creado correctamente')
            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al crear Diners TC')
            return rejectWithValue(error.response?.data)
        }
    }
)

export const updateDetailsByAutomaticDebtDinersTC = createAsyncThunk(
    'cashManagement/updateDetailsDinersTC',
    async ({ id, details }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(
                `/automatic-debts/${id}/update_details_diners_tc/`,
                details
            )

            sucessToast('Registros Diners actualizados')

            dispatch(getCashManagement(id))
            dispatch(fetchDetailsByAutomaticDebtDinersTC({ id, search: '' }))

            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error actualizando Diners TC')
            return rejectWithValue(error.response?.data)
        }
    }
)

export const saveMigrateDebitAutomaticDinersTC = createAsyncThunk(
    'cashManagement/saveMigrateDinersTC',
    async ({ id, details }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `/automatic-debts/${id}/save_migrate_cobro_diners_tc/`,
                details
            )

            sucessToast('Cobros Diners enviados correctamente')
            dispatch(getCashManagement(id))
            dispatch(fetchDetailsByAutomaticDebtDinersTC({ id, search: '' }))

            return response.data
        } catch (error) {
            errorToast(error?.response?.data?.error || 'Error al migrar Diners TC')
            return rejectWithValue(error.response?.data)
        }
    }
)

export const fetchCustomerAgreements = createAsyncThunk(
    'cashManagement/fetchDataCustomers',
    async (
        {
            page = 1,
            page_size = 25,
            search = '',
            agreement_type = ''
        },
        { rejectWithValue }
    ) => {
        try {
            const params = new URLSearchParams()
            params.append('p', page)
            params.append('page_size', page_size)
            if (search) {
                params.append('search', search)
            }
            if (agreement_type) {
                params.append('agreement_type', agreement_type)
            }
            const response = await axiosInstance.get(`/automatic-debts/customers/?${params.toString()}`)
            return response.data

        } catch (error) {

            errorToast(
                error?.response?.data?.error ||
                'Error al obtener clientes'
            )

            return rejectWithValue(error.response.data)
        }
    }
)

export const deleteAgreement = createAsyncThunk(
    'cashManagement/deleteAgreement',
    async (customerId, { rejectWithValue }) => {
        try {

            const response = await axiosInstance.delete(
                `/automatic-debts/${customerId}/delete-agreements/`
            )

            sucessToast(
                response.data.detail ||
                'Convenio eliminado correctamente'
            )

            return response.data

        } catch (error) {

            errorToast(
                error?.response?.data?.detail ||
                error?.response?.data?.error ||
                'No fue posible eliminar el convenio'
            )

            return rejectWithValue(
                error.response?.data
            )
        }
    }
)

export const setStartDate = createAsyncThunk(
    'cashManagement/setStartDate',
    async (startDate, { }) => {
        return startDate
    }
)

export const setEndDate = createAsyncThunk(
    'cashManagement/setEndDate',
    async (endDate, { }) => {
        return endDate
    }
)

const cashManagementSlice = createSlice({
    name: 'appCashManagement',
    initialState: {
        allData: [],             // Lista de cabeceras
        pagination: {},       // Info de paginación
        details: [],          // Detalles por id de cabecera
        details2: [],          // Detalles por id de cabecera
        details3: [],
        details4: [],         // Detalles por id de cabecera
        loading: false,
        preview_data_load: false,
        data: {},
        erros: [],
        totalPages: 0,
        customers: [],
        totalPagesC: 0,
        loadingCustomers: false,
        startDate: null,
        endDate: null
    },
    extraReducers: builder => {
        builder
            .addCase(saveDebitAutomatic.fulfilled, state => {
                state.details = []
            })
            .addCase(saveDebitAutomaticTC.fulfilled, state => {
                state.details2 = []
            })
            // .addCase(saveDebitAutomaticDF.fulfilled, state => {
            //     state.details3 = []
            // })
            // .addCase(saveDebitAutomaticDinersTC.fulfilled, state => {
            //     state.details4 = []
            // })
            .addCase(
                setStartDate.fulfilled,
                (state, action) => {
                    state.startDate = action.payload
                }
            )
            .addCase(
                setEndDate.fulfilled,
                (state, action) => {
                    state.endDate = action.payload
                }
            )
            .addCase(
                fetchCustomerAgreements.pending,
                state => {
                    state.loadingCustomers = true
                }
            )
            .addCase(
                fetchCustomerAgreements.fulfilled,
                (state, action) => {

                    state.loadingCustomers = false

                    state.customers = action.payload

                    state.totalPagesC = Math.ceil(
                        action.payload.count /
                        action.meta.arg.page_size
                    )

                }
            )
            .addCase(
                fetchCustomerAgreements.rejected,
                state => {

                    state.loadingCustomers = false

                }
            )
            .addCase(fetchCashManagement.pending, state => {
                state.loading = true
            })
            .addCase(fetchCashManagement.fulfilled, (state, action) => {
                state.loading = false
                state.allData = action.payload
                state.totalPages = Math.ceil(action.payload.count / action.meta.arg.page_size)
            })
            .addCase(fetchCashManagement.rejected, state => {
                state.loading = false
            })
            .addCase(addCashManagement.pending, state => {
                state.loading = true
            })
            .addCase(addCashManagement.fulfilled, state => {
                state.loading = false
            })
            .addCase(addCashManagement.rejected, state => {
                state.loading = false
            })
            .addCase(fetchDetailsByAutomaticDebt.fulfilled, (state, action) => {
                state.details = action.payload
                state.preview_data_load = false
            })
            .addCase(fetchDetailsByAutomaticDebtTC.fulfilled, (state, action) => {
                state.details2 = action.payload
                state.preview_data_load = false
            })
            .addCase(fetchDetailsByAutomaticDebtDF.fulfilled, (state, action) => {
                state.details3 = action.payload
                state.preview_data_load = false
            })
            .addCase(fetchDetailsByAutomaticDebtDinersTC.fulfilled, (state, action) => {
                state.details4 = action.payload
                state.preview_data_load = false
            })
            .addCase(getCashManagement.pending, state => {
                state.loading = true
            })
            .addCase(getCashManagement.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
                state.preview_data_load = false
            })
            .addCase(getCashManagement.rejected, state => {
                state.loading = false
            })
            .addCase(previewAutomaticDebt.pending, state => {
                state.loading = true
            })
            .addCase(previewAutomaticDebt.fulfilled, (state, action) => {
                state.data = action.payload.header
                const bank = action.payload.header.bank || '1'
                if (bank === '2') {
                    state.details2 = action.payload.detail
                } if (bank === '3') {
                    state.details3 = action.payload.detail
                } else if (bank === '4') {
                    state.details4 = mapVisaToDinersView(action.payload.detail)
                } else {
                    state.details = action.payload.detail
                }
                state.preview_data_load = false
            })
            .addCase(previewAutomaticDebt.rejected, state => {
                state.loading = false
            })
            .addCase(loadDebitAutomatic.pending, state => {
                state.loading = true
            })
            .addCase(loadDebitAutomatic.fulfilled, (state, action) => {
                if (action.payload.preview) {
                    if (action.payload.formato === 2) {
                        state.details2 = action.payload.preview
                    } else if (action.payload.formato === 3) {
                        state.details3 = action.payload.preview
                    } else if (action.payload.formato === 4) {
                        state.details4 = action.payload.preview || []
                    } else {
                        state.details = action.payload.preview
                    }
                }
                state.preview_data_load = true
                state.loading = false
            })
            .addCase(loadDebitAutomatic.rejected, state => {
                state.loading = false
            })
            .addCase(saveMigrateDebitAutomatic.pending, state => {
                state.loading = true
            })
            .addCase(saveMigrateDebitAutomatic.fulfilled, state => {
                // state.errors = action.payload.errors
                state.loading = false
            })
            .addCase(saveMigrateDebitAutomatic.rejected, state => {
                state.loading = false
            })
            .addCase(saveMigrateDebitAutomaticTC.pending, state => {
                state.loading = true
            })
            .addCase(saveMigrateDebitAutomaticTC.fulfilled, state => {
                state.loading = false
            })
            .addCase(saveMigrateDebitAutomaticTC.rejected, state => {
                state.loading = false
            })
            .addCase(saveMigrateDebitAutomaticDinersTC.pending, state => {
                state.loading = true
            })
            .addCase(saveMigrateDebitAutomaticDinersTC.fulfilled, state => {
                state.loading = false
            })
            .addCase(saveMigrateDebitAutomaticDinersTC.rejected, state => {
                state.loading = false
            })
        // .addCase(fetchDetailsByAutomaticDebtVisa.fulfilled, (state, action) => {
        //     state.details4 = action.payload
        //     state.preview_data_load = false
        // })
    }
})

export default cashManagementSlice.reducer